import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from '../style.module.scss';

const Intro = () => {
    const Introduction = useSelector((state: RootState) => state.itinerariesReducer.Introduction);

    return (
        <div className={styles.introduce_wrapper}>
            <div className={styles.introduce} dangerouslySetInnerHTML={{ __html: Introduction }} />
        </div>
    );
};

export default Intro;
